// Cookie / analytics consent. We don't load GA4 until the user explicitly
// opts in. Pre-consent the gtag function in index.html is a no-op stub
// so calling code anywhere in the app is safe.
//
// Storage key carries the version so we can re-prompt if our policy
// materially changes.

const STORAGE_KEY = 'pm_analytics_consent_v1';
const GA4_MEASUREMENT_ID = 'G-4KM8F85RFE';

let loaded = false;

/** 'granted' | 'denied' | null (no decision yet). */
export function getConsentState() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'granted' || v === 'denied') return v;
  } catch { /* ignore */ }
  return null;
}

/** Persist a decision and act on it (load or skip GA4). */
export function setConsentState(value) {
  try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
  if (value === 'granted') loadAnalytics();
  // Note: there's no clean way to fully "unload" GA after it's been loaded
  // in a tab; the next page navigation will skip it. That matches what
  // most consent tools do.
}

/** Inject the GA4 script + initialize it. Idempotent. */
export function loadAnalytics() {
  if (loaded) return;
  if (typeof document === 'undefined') return;
  loaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA4_MEASUREMENT_ID);
}

/** On app boot, opt in if the user previously consented. */
export function initConsent() {
  if (getConsentState() === 'granted') loadAnalytics();
}
